module.exports = __webpack_public_path__ + "static/media/img127_R.8fde3a68.jpg";